"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTMLElementAnchorLoader = void 0;
const gl_matrix_1 = require("gl-matrix");
class HTMLElementAnchorLoader {
    // #endregion Properties (2)
    // #region Constructors (1)
    constructor(_renderingEngine) {
        this._renderingEngine = _renderingEngine;
        // #region Properties (2)
        this._htmlElements = {};
        this._parentDiv = document.createElement('div');
        this._parentDiv.style.userSelect = 'none';
        this._parentDiv.style.cursor = 'default';
        this._parentDiv.style.pointerEvents = 'none';
        this._parentDiv.style.overflow = 'hidden';
        this._parentDiv.style.position = 'absolute';
        this._parentDiv.style.width = '100%';
        this._parentDiv.style.height = '100%';
        this._parentDiv.style.left = '0%';
        this._parentDiv.style.top = '0%';
    }
    // #endregion Constructors (1)
    // #region Public Accessors (1)
    get parentDiv() {
        return this._parentDiv;
    }
    // #endregion Public Accessors (1)
    // #region Public Methods (5)
    adjustPositions(scaleWidth, scaleHeight) {
        for (let anchorId in this._htmlElements) {
            const anchor = this._htmlElements[anchorId];
            const { page, container, client, hidden } = this._renderingEngine.sceneTracingManager.convert3Dto2D(gl_matrix_1.vec3.clone(anchor.location));
            const htmlElement = anchor.createViewerHtmlElement(this._renderingEngine.id);
            if (!htmlElement)
                continue;
            anchor.update({ anchor, htmlElement, page, container, client, scale: gl_matrix_1.vec2.fromValues(scaleWidth, scaleHeight), hidden });
        }
    }
    init() {
        var _a;
        (_a = this._renderingEngine.canvas.parentNode) === null || _a === void 0 ? void 0 : _a.appendChild(this._parentDiv);
    }
    load(anchor) {
        const htmlElement = anchor.createViewerHtmlElement(this._renderingEngine.id);
        if (!htmlElement)
            return;
        this._parentDiv.appendChild(htmlElement);
        this._htmlElements[anchor.id + '_' + anchor.version] = anchor;
    }
    removeData(id, version) {
        const anchor = this._htmlElements[id + '_' + version];
        if (anchor && anchor.getViewerHtmlElement(this._renderingEngine.id)) {
            this._parentDiv.removeChild(anchor.getViewerHtmlElement(this._renderingEngine.id));
            delete this._htmlElements[id + '_' + version];
        }
    }
    toggleBlur(toggle) {
        if (toggle) {
            if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 && navigator.userAgent.toLowerCase().indexOf('android') > -1)
                return;
            this._parentDiv.style.filter = 'blur(3px)';
        }
        else {
            this._parentDiv.style.filter = '';
        }
    }
}
exports.HTMLElementAnchorLoader = HTMLElementAnchorLoader;
//# sourceMappingURL=HTMLElementAnchorLoader.js.map